const MODULE_PREFIX = 'ux';
const initialState = { addCommentDisabled: false, addReplyDisabled: false };

const actions = {
  disableAddComment: ({ commit }, disable) => {
    commit('mutateAddCommentDisabled', disable);
  },
  disableAddReply: ({ commit }, disable) => {
    commit('mutateAddReplyDisabled', disable);
  },
};

const getters = {
  addCommentDisabled: state => state.addCommentDisabled,
  addReplyDisabled: state => state.addReplyDisabled,
};

const mutations = {
  mutateAddCommentDisabled: (state, disable) => { state.addCommentDisabled = disable; },
  mutateAddReplyDisabled: (state, disable) => { state.addReplyDisabled = disable; },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  actions: {
    disableAddComment: `${MODULE_PREFIX}/disableAddComment`,
    disableAddReply: `${MODULE_PREFIX}/disableAddReply`,
  },
  getters: {
    addCommentDisabled: `${MODULE_PREFIX}/addCommentDisabled`,
    addReplyDisabled: `${MODULE_PREFIX}/addReplyDisabled`,
  },
  mutations: {
    mutateAddCommentDisabled: `${MODULE_PREFIX}/mutateAddCommentDisabled`,
    mutateAddReplyDisabled: `${MODULE_PREFIX}/mutateAddReplyDisabled`,
  },
};
